import { SessionProvider } from '@/_providers/session-provider'
import { DashboardHeader } from '@/features/_components/dashboard-header'
import { DashboardSidebar } from '@/features/_components/dashboard-sidebar'
import { useSidebarStore } from '@/features/_stores'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

const COLLAPSE_BREAKPOINT = 1280

export const Route = createFileRoute('/_authed')({
  component: AuthedLayout,
})

function AuthedLayout() {
  const setCollapsed = useSidebarStore((s) => s.setCollapsed)

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${COLLAPSE_BREAKPOINT}px)`)

    const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
      setCollapsed(e.matches)
    }

    handleChange(mql)
    mql.addEventListener('change', handleChange)
    return () => mql.removeEventListener('change', handleChange)
  }, [setCollapsed])

  return (
    <SessionProvider>
      <div className="flex h-screen overflow-hidden">
        <DashboardSidebar />
        <div className="flex flex-1 flex-col overflow-hidden">
          <DashboardHeader />
          <div className="flex-1 overflow-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </SessionProvider>
  )
}
